import React from 'react';
import { PackImage } from './PackImage';
import { CountdownTimer } from './CountdownTimer';
export function OfferSection() {
  return <section id="compra" className="py-20 px-4 bg-cream relative" data-id="element-112">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-[100px] pointer-events-none" data-id="element-113"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-114">
        <div className="mb-8" data-id="element-115">
          <span className="inline-block bg-red-600 text-white font-bold px-4 py-2 rounded-full mb-4 animate-pulse" data-id="element-116">
            OFERTA POR TIEMPO LIMITADO
          </span>
          <div className="flex justify-center mb-8" data-id="element-117">
            <CountdownTimer variant="inline" data-id="element-118" />
          </div>
        </div>

        <div className="mb-12" data-id="element-119">
          <PackImage data-id="element-120" />
        </div>

        <div className="bg-white border border-warm-400 rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-121">
          <p className="text-xl text-warm-700 mb-2" data-id="element-122">
            El valor total de todo este contenido supera fácilmente los
          </p>
          <p className="text-3xl text-warm-600 line-through mb-6 decoration-red-500 decoration-4" data-id="element-123">
            $79.990 ARS
          </p>

          <p className="text-2xl text-warm-900 mb-2" data-id="element-124">
            Pero hoy podés obtener acceso completo por solo
          </p>
          <div className="text-6xl md:text-8xl font-bold text-primary mb-4 drop-shadow-[0_0_15px_rgba(212,133,10,0.3)]" data-id="element-125">
            $19.990{' '}
            <span className="text-3xl md:text-4xl text-primary/80" data-id="element-126">ARS</span>
          </div>
          <p className="text-lg text-warm-700 mb-8 uppercase tracking-widest" data-id="element-127">
            Un único pago
          </p>

          <a href="http://checkout.sabores365.online/cart/58343606157393:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-primary hover:bg-primary-hover text-white font-bold text-xl md:text-2xl py-6 px-8 rounded-xl shadow-[0_0_30px_rgba(212,133,10,0.3)] hover:shadow-[0_0_50px_rgba(212,133,10,0.5)] transition-all duration-300 hover:scale-105 mb-6" data-id="element-128">
            OBTENER MI PACK COMPLETO POR SOLO $19.990
          </a>

          <p className="text-sm text-warm-700 max-w-lg mx-auto" data-id="element-129">
            Una vez que completes tu compra vas a poder descargar el libro
            inmediatamente y empezar a preparar recetas deliciosas desde hoy
            mismo.
          </p>
        </div>
      </div>
    </section>;
}